<!--suppress CheckEmptyScriptTag -->
<template>
  <div>
    <fields
      :fields="fields.all()"
      :model="item"
      layout="vertical" />
  </div>
</template>

<script>

import { FormMixin } from 'stylemix-base';

const fields = [{
  "attribute": "id",
  "label": "Category",
  "component": "select-field",
  "options": window.categories
}, {
  "attribute": 'image',
  "label": "Image",
  "component": 'image-field',
}, {
  "attribute": 'image_webp',
  "label": "Webp",
  "component": 'image-field',
}];

export default {
  name: 'CategoryBlockForm',

  mixins: [FormMixin],

  props: {
    item: Object
  },

  created() {
    fields[0].options = window.categories;
    this.setFields(fields);
  },

}
</script>
